import { styled } from '@feast-it/ui/light';

export const SupplierCardContainer = styled.div`
  width: 100%;
  min-width: 0;
  article {
    width: 100%;
    height: 100%;
  }
`;
